import moment from "moment";
import { calendarApi } from "src/api/calendar";
import { collectionApi } from "src/api/collection";
import { deliveryApi } from "src/api/delivery";
import { draftOrderApi } from "src/api/draft-order";
import { fulfillmentApi } from "src/api/fulfillment";
import { logApi } from "src/api/log";
import { orderApi } from "src/api/order";
import { AppThunk } from "src/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationState {
    openOrders: number;
    openFulfillments: number;
    openCollections: number;
    deliveries: number;
    draftOrders: number;
    events: number;
    logs: number;
    productsToOrder: number;
    total?: number;
}

const initialState: NotificationState = {
    openOrders: 0,
    openFulfillments: 0,
    openCollections: 0,
    deliveries: 0,
    draftOrders: 0,
    events: 0,
    logs: 0,
    productsToOrder: 0,
    total: 0,
};

const slice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        getNotifications(state: NotificationState, action: PayloadAction<NotificationState>): void {
            // Disabled notifications - always return 0
            state.openOrders = 0;
            state.openFulfillments = 0;
            state.openCollections = 0;
            state.deliveries = 0;
            state.draftOrders = 0;
            state.events = 0;
            state.productsToOrder = 0;
            state.logs = 0;
            state.total = 0;
        },
    },
});

export const { reducer } = slice;

export const getNotifications =
    (): AppThunk =>
    async (dispatch): Promise<void> => {
        // Notifications disabled - skip all API calls and return zeros
        dispatch(
            slice.actions.getNotifications({
                openOrders: 0,
                openFulfillments: 0,
                openCollections: 0,
                deliveries: 0,
                draftOrders: 0,
                events: 0,
                logs: 0,
                productsToOrder: 0,
            })
        );
    };

export default slice;
